import styled from '@emotion/styled'

const Directions = styled.p`
  font-size: 0.9rem;
  margin: ${(props) => (props.extraMargin ? '1rem 0' : '0')};
  color: ${(props) => props.theme.directions.color};
`

export default Directions
